module.exports = __webpack_public_path__ + "static/media/coffee.ade507c3.png";